<template>
  <div>
    <page-table />
  </div>
</template>
<script>
import PageTable from './components/table/index'
export default {
  name: 'purchase-materialPurchase',
  components: {
    PageTable,
  },
}
</script>
